import './login.less';

/** Alterna a visibilidade dos campos de senha marcados com .auth-olho. */
function iniciarOlhos(): void {
    document.querySelectorAll<HTMLButtonElement>('.auth-olho').forEach(botao => {
        botao.addEventListener('click', () => {
            const campo = botao.parentElement?.querySelector<HTMLInputElement>('input');
            const icone = botao.querySelector('i');
            if (!campo || !icone) return;

            const oculto = campo.type === 'password';
            campo.type = oculto ? 'text' : 'password';
            icone.classList.toggle('bi-eye', !oculto);
            icone.classList.toggle('bi-eye-slash', oculto);
        });
    });
}

// A protecao contra duplo envio e global, vive em site.ts.
document.addEventListener('DOMContentLoaded', iniciarOlhos);
